import { Observable } from 'rxjs';
import { AdminsApi, PagedPersonResponse } from 'src/app/hickory-api';
import { mockHandler } from '../mock.handler';

export class MockAdminsApi extends AdminsApi {
  admins: PagedPersonResponse = {
    totalItemCount: 10,
    pageCount: 1,
    page: 1,
    pageSize: 25,
    items: [
      {
        id: 1000,
        name: {
          familyName: 'LastName',
          givenName: 'FirstName'
        },
        assetIds: [
          'default_facility'
        ],
        externalId: '1004'
      }
    ],
    hasErrors: false,
    isValid: true
  };

  getAdmins(ids?: Array<number>, externalIds?: Array<string>, groupId?: number, search?: string, permissions?: Array<string>, permissionSearchOption?: 'All' | 'Any', includeAssets?: boolean, includeChatId?: boolean, includePermissions?: boolean, page?: number, pageSize?: number, sort?: string)
    : Observable<any> {
    const response: PagedPersonResponse = this.admins;
    return mockHandler(response);
  }
}
